<template>
  <v-container max-width="600" class="fill-height" v-if="profile">
    <v-row justify="center">
      <v-col cols="12" lg="4" md="6">

        <div class="text-center mb-2 logoImage">
          <img src="../assets/logo/Logo.svg" alt="">
        </div>

        <v-card elevation="0" style="border: 1px solid #dddddd;border-radius: 20px;position: relative" id="card"
                class="text-center pa-4">
          <v-img
              :src="profile.imageUrl || placeholder"
              class="mb-4"
              contain
          ></v-img>
          <!--          <img src="../assets/psyche/2.jpg" class="" width="100%" alt="">-->

          <div>روانشناس مناسب شما:</div>
          <div style="font-weight: bolder;font-size: 1.2em;">{{ profile.name }}</div>
          <div>با رویکرد <span style="font-weight: bolder;">{{ profile.approach }}</span></div>
          <div class="mt-3"><span style="">[</span> {{ randomQuote }} <span>]</span></div>
          <div></div>

          <div></div>
          <!--          <v-card-text class="subtitle-1 font-italic">-->
          <!--            {{ profile.aiMessage }}-->
          <!--          </v-card-text>-->

          <ShareButtons :profile="profile" class="mt-4"/>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" lg="4" md="6">
        <div class="text-center">
          تراپیست‌های سیمیاروم با رویکردهای علمی مختلف، هرکدام از دیدگاه ویژه‌ای در مسیر بهبود همراه شما هستند.
          <div></div>
          <v-btn href="https://simiaroom.com/counselor/?cm" class="my-3" elevation="0" block color="primary">آشنایی
            بیشتر
          </v-btn>
        </div>
        <div class="actionArea">
          <div class="titleActionArea">

          </div>
        </div>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import {mapState} from "vuex";
import ShareButtons from "./ShareButtons.vue";

export default {
  name: "PsychResult",
  components: {ShareButtons},
  computed: {
    ...mapState("psychTest", {profile: "result"}),
    placeholder() {
      return "https://placehold.co/600x250?text=City";
    },
    randomQuote() {
      if (this.profile) {
        const randomIndex = Math.floor(Math.random() * this.profile.quotes.length);
        return this.profile.quotes[randomIndex];
      }
      return '';
    }
  },
};
</script>
<style scoped>
.titleActionArea {
  font-weight: 700;
  font-size: 20px;
  text-align: center;
}

/*.logoImage{*/
/*  position: absolute;*/
/*  top: 40px;*/
/*  left: 50%;*/
/*  transform: translate(-50%, -50%);*/
/*}*/
</style>
